import React from 'react'
import Intro from '../components/Intro/intro'

const Home = () => {
  return (
    <div>
      <Intro />
    </div>
  )
}

export default Home
